// service/crm/hooks/useContactImportErrors.ts

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  contactImportApi,
  contactImportQueryKeys,
} from "service/crm/api/contactImport";
import {
  CONTACT_IMPORT_PAGE_SIZE,
  ContactImportErrorCategory,
} from "types/crm/contactImport";

/**
 * One page of the import's error log.
 *
 * The job itself carries a preview of the first hundred; this is the log
 * proper, paged and filterable. Which log it is depends on where the job has
 * got to — the dry run's findings after validate, that run's own once it has
 * been started.
 */
export const useContactImportErrors = (
  importUuid?: string,
  page = 0,
  size: number = CONTACT_IMPORT_PAGE_SIZE,
  category?: ContactImportErrorCategory,
  enabled = true
) =>
  useQuery({
    queryFn: () =>
      contactImportApi.getImportErrors(importUuid as string, {
        page,
        size,
        category,
      }),
    queryKey: contactImportQueryKeys.errors(
      importUuid ?? "",
      page,
      size,
      category
    ),
    enabled: Boolean(importUuid) && enabled,
    // The log is rewritten by a re-validate and again by the run itself, so
    // what was read a moment ago is not to be trusted on the next look.
    staleTime: 0,
    // Turning a page keeps the one before it on screen rather than emptying the
    // panel and collapsing it — the controls stay where the user left them.
    placeholderData: keepPreviousData,
  });
